

// main

window.addEventListener('pageshow', function() {
  setTimeout( function() {
    if($('body').attr('data-status') != 'loaded') {
      loadContents();
    }
  }, 1000);
});


var userAgent = window.navigator.userAgent.toLowerCase();
var is_ie = (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) ? true : false;


$('.js-rotate3d').each(function() {
  rotate3d($(this));
});


$('a:not([href^="tel:"]):not([target])').on('click tap', function(e) {

  var ref = location.href;
  var url = $(this).attr('href');

  if( ref.indexOf(url.replace(/#.*$/, '')) != -1 && url.indexOf('#') != -1 ) {

    var speed = 300;
    var href= url.match(/#.*$/);
    var target = $(href[0]);
    var position = target.offset().top - $('.js-header').outerHeight();
    $('body, html').animate({ scrollTop: position }, speed, 'swing');
    return false;

  } else {

    e.preventDefault();
    url = $(this).attr('href');
    if (url !== '') {
      $('body').attr('data-status', 'loadstart');
      setTimeout(function() {
        window.location = url;
      }, 200);
    }
    return false;

  }

});


$('.js-accrodion-btn').on('click tap', function(e) {
  $(this).next('.js-accrodion-target').slideToggle();
  $(this).toggleClass('is-active');
});


$('.js-p-entry-forms-form-select').on('change', function(e) {

  var key = $(this).val();
  var job = $(this).find(':selected').text();

  $('.js-entry-forms-switch[data-form-value="'+key+'"] [name="希望職種"]').val(job);

  if(
    !$('.js-entry-forms-switch[data-form-value="'+key+'"]').hasClass('is-active') &&
    key != ''
  ) {
    $('.js-entry-forms-switch').removeClass('is-active');
    $('.js-entry-forms-switch[data-form-value="'+key+'"]').addClass('is-active');
  }

  $('.js-p-entry-forms-form-select option[value=""]').remove();

});


$(window).on('load resize', function() {

  if( $('.js-grid-col')[0] && $('.js-grid-col .js-grid-col-text')[0] ) {
    $('.js-grid-col .js-grid-col-text').matchHeight();
  }

  set_liquid_font_size('.p-main-visual-copy-ttl-sub', '.p-main-visual-img', 2.8);
  set_liquid_font_size('.p-main-visual-copy-ttl-main', '.p-main-visual-img', 9);
  set_liquid_font_size('.p-main-visual-copy-ttl-ja', '.p-main-visual-img', 2.5);
  set_liquid_arw_width('.p-main-visual-scroll-obj-img', '.p-main-visual-img', .8);
  set_liquid_arw_height('.p-main-visual-scroll-obj-img', '.p-main-visual-img', 2);

});


function set_liquid_font_size(elm, parent, size) {
  var h = $(parent).outerHeight();
  var percent = (h * (size / 100));
  $(elm).css('font-size', percent + 'px');
}


function set_liquid_arw_width(elm, parent, size) {
  var h = $(parent).outerHeight();
  var percent = (h * (size / 100));
  $(elm).css('width', percent + 'px');
}

function set_liquid_arw_height(elm, parent, size) {
  var h = $(parent).outerHeight();
  var percent = (h * (size / 100));
  $(elm).css('height', percent + 'px');
}


// Lazy Load
$(window).on('load resize scroll', function() {

  // Background
  $('[data-lazy-background]').each(function() {
    if ($(window).scrollTop() + $(window).height() > $(this).offset().top) {
      $(this).css('background-image', 'url('+$(this).data('lazy-background')+')');
      $(this).removeAttr('data-lazy-background');
    }
  });

  // img
  $('[data-lazy-img]').each(function() {
    if ($(window).scrollTop() + $(window).height() > $(this).offset().top) {
      $(this).attr('src', $(this).data('lazy-img'));
      $(this).removeAttr('data-lazy-img');
    }
  });

});


$(window).on('load scroll', function() {

  if( $('.js-pagetop')[0] ) {
    var h = $(window).height();
    var scrollTop = $(window).scrollTop();
    if (scrollTop > h / 2) {
      $('.js-pagetop').addClass('is-active');
    }
    else {
      $('.js-pagetop').removeClass('is-active');
    }
  }

});


$(window).on('load', function() {

  $('.js-menu-toggle').on('click tap', function() {
    var status = $('body').attr('data-menu');
    if( status == 'active' ) {
      $('body').attr('data-menu', '');
    } else {
      $('body').attr('data-menu', 'active');
    }
  });

  $('.p-pagetop').on('click tap', function() {
    $('body, html').animate({
      scrollTop: 0
    }, 300, 'swing');
  });

  if( $('.js-main-about-member')[0] ) {
    new Swiper('.js-main-about-member .swiper-container', {
      loop: true,
      slidesPerView: 1,
      slideWidth: 300,
      speed: 1000,
      autoplay: {
        delay: 4000,
      },
      navigation: {
        nextEl: '.js-main-about-member-next',
        prevEl: '.js-main-about-member-prev',
      },
    });
  }

  if( $('.js-main-interview')[0] ) {
    new Swiper('.js-main-interview .swiper-container', {
      loop: true,
      slidesPerView: 1,
      slideWidth: 300,
      speed: 1000,
      autoplay: {
        delay: 4000,
      },
      navigation: {
        nextEl: '.js-main-interview-next',
        prevEl: '.js-main-interview-prev',
      },
    });
  }

  if( $('.js-interview-recommend')[0] && $('.js-interview-recommend .swiper-slide').length > 1 ) {
      var recommendSlider = new Swiper('.js-interview-recommend .swiper-container', {
      loop: true,
      slidesPerView: 3,
      slidesPerGroup: 3,
      speed: 1000,
      autoplay: {
        delay: 4000,
      },
      navigation: {
        nextEl: '.js-interview-recommend-next',
        prevEl: '.js-interview-recommend-prev',
      },
      watchOverflow: true,
      noSwiping: true,
      noSwipingClass: 'is-no-swiping-pc',
      breakpoints: {
        1024: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          noSwipingClass: 'is-no-swipe-disabled',
        },
        767: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          noSwipingClass: 'is-no-swipe-disabled',
        },
      },
    });

    if( $('.js-interview-recommend').hasClass('is-disabled-pc') && !is_mobile() ) {
      recommendSlider.autoplay.stop();
    }
  }

  if( location.hash && $(location.hash)[0] ) {

    var hash = location.hash;

    setTimeout( function() {
      $('body, html').animate({ scrollTop: $(hash).offset().top - $('.js-header').outerHeight() }, 0, 'linear');
    }, 300 );

    $('.p-gnav-link').each(function() {
      if(location.href.indexOf($(this).attr('href')) > 0) {
      $('.p-gnav-link').removeClass('is-active');
        $(this).addClass('is-active');
      }
    });

    if( $(location.hash).hasClass('js-accrodion-btn') ) {
      $(location.hash).trigger('click');
    }

  }

  if( $('.js-entry-forms-switch')[0] ) {

    // console.log(document.referrer);
    // console.log(getParam('key', document.referrer));

    var formKey = getParam('key', document.referrer);

    if( formKey && formKey != ''&& formKey != null ) {

      $('.js-p-entry-forms-form-select option[value="'+formKey+'"]').attr('selected', 'selected');
      $('.js-p-entry-forms-form-select').change();

      setTimeout( function() {
        $('body, html').animate({ scrollTop: $('#entry').offset().top - $('.js-header').outerHeight() }, 0, 'swing');
      }, 300 );

    }

  }

  loadContents();

});


function is_mobile() {
  if (
    (navigator.userAgent.indexOf('iPhone') > 0 && navigator.userAgent.indexOf('iPad') == -1) ||
    navigator.userAgent.indexOf('iPod') > 0 ||
    navigator.userAgent.indexOf('Android') > 0
  ) {
    return true;
  }
  else {
    return false;
  }
}


function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[[]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


function loadContents() {

  var content_show_timeout = ( location.hash && $(location.hash)[0] ) ? 300 : 200;
  var animate_start_timeout = ( location.hash && $(location.hash)[0] ) ? 300 : 200;

  setTimeout(function() {

    $('body').attr('data-status', 'loaded');

  }, content_show_timeout);

  setTimeout(function() {

    var timer = false;
    $(window).on('scroll', function () {

      eachAnimate();

      if( timer !== false ){
        clearTimeout( timer );
      }

      timer = setTimeout( function() {
        eachAnimate();
      }, 400 );

    });

    eachAnimate();
    setTimeout( function() {
      eachAnimate();
    }, 400 );

    if( $('.js-main-visual-slide')[0] ) {

      var mainVisualSwiper = new Swiper('.js-main-visual-slide .swiper-container', {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
        slidesPerView: 1,
        speed: 1000,
        autoplay: {
          delay: 3000,
        },
        noSwiping: true,
        on: {
          slideChange: function () {
            var mainTitle = $('.js-main-visual-ttl');
            var classList = this.slides[this.activeIndex].classList.value;
            mainTitle.removeClass('is-white');
            if (classList.indexOf('swiper-slide-white') >= 0) {
              mainTitle.addClass('is-white');
            }
          },
        },
      });

      setTimeout( function() {
        // mainVisualSwiper.slideNext();
        setTimeout( function() {
          // mainVisualSwiper.autoplay.start();
        }, 5000 );
      }, 1200 );

    }

    afterLoadFile('https://fonts.googleapis.com/css?family=Josefin+Sans:400,700&display=swap', 'css');
    afterLoadFile('https://use.fontawesome.com/releases/v5.6.1/css/all.css', 'css');

    $('body').append("<script type='text/javascript'>window._pt_lt = new Date().getTime();window._pt_sp_2 = [];_pt_sp_2.push('setAccount,5e14cb3d');var _protocol = (('https:' == document.location.protocol) ? ' https://' : ' http://');(function() {var atag = document.createElement('script'); atag.type = 'text/javascript'; atag.async = true;atag.src = _protocol + 'js.ptengine.jp/pta.js';var s =document.getElementsByTagName('script')[0];s.parentNode.insertBefore(atag, s);})();</script>");

  }, animate_start_timeout);

}


function rotate3d(elm) {
  elm
    .on('mouseenter', function(e) {
      $(this)
        .attr('data-hover', 'start')
        .delay(200)
        .queue(function(next) {
          $(this).attr('data-hover', 'end'); next();
        });
    })
    .on('mousemove', function(e) {
      var offset = $(this).offset();
      var ax = -( $(this).outerWidth() / 2 - (e.pageX - offset.left) ) / 15;
      var ay = ( $(this).outerHeight() / 2 - (e.pageY - offset.top) ) / 30;
      $(this).children().attr('style', 'transform: perspective(1000px) scale3d(1, 1, 1) rotateY('+ax+'deg) rotateX('+ay+'deg);-webkit-transform: perspective(1000px) scale3d(1, 1, 1) rotateY('+ax+'deg) rotateX('+ay+'deg);-moz-transform: perspective(1000px) scale3d(1, 1, 1) rotateY('+ax+'deg) rotateX('+ay+'deg)');
    })
    .on('mouseleave', function(e) {
      $(this).children().attr('style', 'transform: perspective(1000px) scale3d(1, 1, 1) rotateY(0deg) rotateX(0deg);-webkit-transform: perspective(1000px) scale3d(1, 1, 1) rotateY(0deg) rotateX(0deg);-moz-transform: perspective(1000px) scale3d(1, 1, 1) rotateY(0deg) rotateX(0deg)');
    });
}


function eachAnimate() {
  $('.js-animate').each(function () {
    var pos = $(this).offset().top;
    var h = $(window).height();
    var offset = ($(this).data('offset')) ? $(this).data('offset') : 200;
    var scrollTop = $(window).scrollTop() + offset;
    if (scrollTop > pos - h / 1.5) {
      $(this).addClass('is-active');
      $(this).removeClass('js-animate');
    }
  });
}


function afterLoadFile(src, type) {

  if( type == 'js' ) {
    $('body').append('<script src="'+src+'"></script>');
  }

  else if( type == 'css' ) {
    $('body').append('<link rel="stylesheet" href="'+src+'">');
  }

  else {
    return false;
  }

}

